/* eslint-disable camelcase */
import actions from 'react/api/actions';
import { fromJS } from 'immutable';

const initialState = fromJS({
  user: {
    j_username: '',
    j_password: '',
    g_recaptcha_response: ''
  },
  errors: [],
  success: [],
  loading: false,
  showModal: false,
  showToast: false,
  showRecaptcha: false,
  showSuccessAtForgotPass: false,
  showErrorPassword: false,
  showErrorUsername: false,
  showLoginError: false,
  identityProvidersList: [],
  showTimeoutLogoffNotice: false
});

export default (state = initialState, action) => {
  if (actions.auth.actions.login === action.type || actions.auth.actions.request === action.type) {
    return state.merge({
      loading: true,
      showTimeoutLogoffNotice: false,
    });
  }
  if (actions.auth.actions.logout === action.type) {
    return state.merge({
      user: {
        j_username: '',
        j_password: '',
        g_recaptcha_response: ''
      },
      errors: [],
      loading: false,
      showModal: false,
      showToast: false,
      showRecaptcha: false
    });
  }

  if (actions.auth.actions.loginFailure === action.type) {
    const { error, showRecaptcha } = action.payload;
    const exceptionToShowModal = 'CredentialsExpiredException';
    return state.merge({
      loading: false,
      errors: action.payload,
      showModal: error === exceptionToShowModal,
      showToast: true,
      showRecaptcha: Boolean(showRecaptcha)
    });
  }

  if (actions.auth.actions.loginOnChange === action.type) {
    const { id, value } = action.payload;
    return state.mergeIn(['user', id], value);
  }

  if (actions.auth.actions.setAttr === action.type) {
    const { id, value } = action.payload;
    return state.mergeIn([id], value);
  }

  if (actions.auth.actions.setRecaptchaResponse === action.type) {
    return state.mergeIn(['user', 'g_recaptcha_response'], action.payload);
  }

  if (actions.auth.actions.getIdentityProvidersListSucceeded === action.type) {
    return state.set('identityProvidersList', fromJS(action.payload));
  }
  if (action.type === actions.auth.actions.showErrorsAtLogin) {
    const { j_username, j_password } = action.payload;
    const errors = {
      showErrorPassword: !j_password,
      showErrorUsername: !j_username,
      showLoginError: false,
      loading: false
    };
    if (!j_username && !j_password) {
      errors.showErrorPassword = false;
      errors.showErrorUsername = false;
      errors.showLoginError = true;
    }
    return state.merge(errors);
  }
  if (action.type === actions.auth.actions.showErrorsAtForgotPass) {
    
    const username = action.payload;
    const errors = {
      showErrorUsername: !username,
      showErrorPassword: false,
      showLoginError: false,
      loading: false
    };
    if (!username) {
      errors.showErrorPassword = false;
      errors.showErrorUsername = true;
      errors.showLoginError = false;
    }
    return state.merge(errors);
  }
  if (action.type === actions.auth.actions.showSuccessAtForgotPass) {
    
    const username = action.payload;
    const success = {
      showSuccessAtForgotPass: false
    };
    const errors = {
      showErrorPassword: false,
      showErrorUsername: !username,
      showLoginError: false,
      loading: false,
    };
    if(username) {
      success.showSuccessAtForgotPass = true;
      errors.showErrorPassword = false;
      errors.showErrorUsername = false;
      errors.showLoginError = false;
    }
    return state.merge(errors), state.merge(success);
  }
  if (action.type === actions.auth.actions.forgotPassBacktoInitialState) {
    const success = {
      showSuccessAtForgotPass: false
    };
    const errors = {
      showErrorUsername: false,
      showLoginError: false,
      loading: false
    };
      success.showSuccessAtForgotPass = false; 
      errors.showErrorPassword = false;
      errors.showErrorUsername = false;
      errors.showLoginError = false;

    return state.merge(errors), state.merge(success);
  }
  if (action.type === actions.auth.actions.showTimeoutLogoffNotice) {
    return state.set('showTimeoutLogoffNotice', true);
  }

  return state;
};
